var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "session-wrapper justify-center justify-md-start",
      attrs: {
        "aria-live": "polite"
      }
    },
    [
      _c("div", {
        staticClass: "session-left"
      }),
      _c(
        "div",
        {
          staticClass: "session-right text-center"
        },
        [
          _c(
            "div",
            {
              staticClass: "session-content",
              attrs: {
                role: "main"
              }
            },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "login"
                    },
                    "aria-label": "Login page"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-responsive mb-3",
                    attrs: {
                      src: _vm.logotype,
                      id: "focus-target",
                      tabindex: "0",
                      alt: "Green Geeks logo",
                      "aria-label": "Green Geeks logo",
                      title: "Green Geeks logo",
                      role: "banner"
                    }
                  })
                ]
              ),
              _c(
                "h1",
                {
                  staticClass: "mb-3 login-heading"
                },
                [_vm._v("Password Reset")]
              ),
              !_vm.isHashAvailable
                ? _c(
                    "v-form",
                    {
                      staticClass: "mb-4"
                    },
                    [
                      !_vm.show_explanation
                        ? _c(
                            "div",
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.rules.email,
                                    expression: "rules.email"
                                  }
                                ],
                                attrs: {
                                  label: "E-mail",
                                  outlined: "",
                                  "data-vv-name": "email",
                                  "data-vv-as": "Email",
                                  "error-messages": _vm.errors.collect("email")
                                },
                                model: {
                                  value: _vm.request_model.email,
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.request_model,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "request_model.email"
                                }
                              }),
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    type: "submit",
                                    tile: "",
                                    block: "",
                                    dark: "",
                                    large: "",
                                    loading: _vm.loading
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.resetPasswordRequest($event)
                                    }
                                  }
                                },
                                [_vm._v(" Reset Password ")]
                              ),
                              _c(
                                "p",
                                [
                                  _c("br"),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "login"
                                        }
                                      }
                                    },
                                    [_vm._v("Go Back")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "body-2 font-weight-regular"
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  " If you have a GreenGeeks Account, a password reset link has been sent to your email. Please check this message for further instructions. "
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  " Password reset links expire after two hours. "
                                )
                              ])
                            ]
                          )
                    ]
                  )
                : _c("v-form", [
                    _vm.show_password_form
                      ? _c(
                          "div",
                          [
                            _c(
                              "p",
                              {
                                staticClass: "body-2 font-weight-regular"
                              },
                              [_vm._v("Enter in your new password.")]
                            ),
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.password,
                                  expression: "rules.password"
                                }
                              ],
                              ref: "password",
                              attrs: {
                                label: "Password",
                                type: _vm.passwordInputType,
                                outlined: "",
                                "data-vv-name": "password",
                                "data-vv-as": "Password",
                                "error-messages": _vm.errors.collect("password")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function fn() {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-0 mr-1",
                                            attrs: {
                                              icon: "",
                                              ripple: false
                                            },
                                            on: {
                                              click: _vm.togglePasswordInput
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "#C2C2C2"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.passwordToggleIcon)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2578315058
                              ),
                              model: {
                                value: _vm.do_model.password,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.do_model, "password", $$v)
                                },
                                expression: "do_model.password"
                              }
                            }),
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.confirmPassword,
                                  expression: "rules.confirmPassword"
                                }
                              ],
                              attrs: {
                                label: "Confirm Password",
                                type: "password",
                                outlined: "",
                                "data-vv-name": "confirmPassword",
                                "data-vv-as": "Confirm Password",
                                "error-messages": _vm.errors.collect(
                                  "confirmPassword"
                                )
                              },
                              model: {
                                value: _vm.do_model.confirmPassword,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.do_model, "confirmPassword", $$v)
                                },
                                expression: "do_model.confirmPassword"
                              }
                            }),
                            _c(
                              "div",
                              [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      type: "submit",
                                      block: "",
                                      tile: "",
                                      large: "",
                                      loading: _vm.loading
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        return _vm.doResetPassword($event)
                                      }
                                    }
                                  },
                                  [_vm._v(" Reset Password ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                size: 50,
                                color: "primary",
                                indeterminate: ""
                              }
                            })
                          ],
                          1
                        )
                  ])
            ],
            1
          )
        ]
      ),
      _c("cookie-law", {
        attrs: {
          theme: "dark-lime"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function fn(props) {
              return [
                _c("p", [
                  _vm._v(
                    " This website uses cookies to ensure you get the best experience on our services. "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.greengeeks.com/legal/privacy",
                        target: "_blank"
                      }
                    },
                    [_vm._v("More details")]
                  )
                ]),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      color: "primary",
                      tile: ""
                    },
                    on: {
                      click: props.accept
                    }
                  },
                  [_vm._v("Got it!")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }